import { trpcQueryUtils } from '@client/trpc/client';
import type { CuriumQueryMeta } from '@client/trpc/query-meta';
import { logInDev } from '@client/utils';
import { DEFAULT_ORG_SETTINGS } from '@shared/constants';
import type { OrgSettings } from '@shared/types';
import { create } from 'zustand';

type OrgSettingsState = {
    isInitialized: boolean;
    orgSetting: OrgSettings;
    init: (orgId: bigint, options?: { queryMeta?: CuriumQueryMeta }) => Promise<void>;
    reload: (orgId: bigint) => Promise<void>;
};
export const useOrgSettingsStore = create<OrgSettingsState>((set, get) => ({
    isInitialized: false,
    trpc: undefined,
    orgSetting: DEFAULT_ORG_SETTINGS,
    client: null,
    canBeInitialized: false,

    init: async (orgId: bigint, options) => {
        try {
            set({ isInitialized: false });
            const data = await trpcQueryUtils.org.getOrgSettings.fetch(
                { orgId },
                {
                    retry: false,
                    staleTime: 30_000,
                    ...(options?.queryMeta ? { meta: options.queryMeta } : {}),
                },
            );
            set({
                orgSetting: data,
                isInitialized: true,
            });
        } catch (e) {
            logInDev('OrgSettingStore.init failed', e);
        }
    },

    reload: async (orgId: bigint) => {
        await trpcQueryUtils.org.getOrgSettings.invalidate({ orgId });
        await get().init(orgId);
    },
}));

// Selector functions
export const selectIsInitialized = (state: OrgSettingsState) => state.isInitialized;
export const selectAllSettings = (state: OrgSettingsState) => state.orgSetting;
